'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var qs = _interopDefault(require('qs'));

var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));

var _asyncToGenerator = _interopDefault(require('@babel/runtime/helpers/asyncToGenerator'));

var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));

var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));

var graphqlRequest = require('graphql-request');

var Wings = /*#__PURE__*/function () {
  function Wings(_ref) {
    var _this = this;

    var _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === void 0 ? 'https://api.wings.dev' : _ref$endpoint,
        appKey = _ref.appKey,
        project = _ref.project;

    _classCallCheck(this, Wings);

    _defineProperty(this, "authHeaders", function () {
      return {
        Authorization: "Bearer ".concat(_this.appKey),
        'X-Wings-Project': _this.project
      };
    });

    this.endpoint = endpoint;
    this.appKey = appKey;
    this.project = project;
    this.client = new graphqlRequest.GraphQLClient(endpoint, {
      headers: {
        Authorization: "Bearer ".concat(appKey),
        'X-Wings-Project': project
      }
    });
  }

  _createClass(Wings, [{
    key: "query",
    value: function () {
      var _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$client;

        var _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$client = this.client).request.apply(_this$client, _args));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function query() {
        return _query.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return Wings;
}();

var mediaUrl = function mediaUrl(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url) return null;
  if (!Object.keys(opts).length) return url;
  var w = opts.width,
      h = opts.height;
  return "".concat(url, "?").concat(qs.stringify({
    w: w,
    h: h,
    quality: w || h ? 100 : undefined
  }));
};

exports["default"] = Wings;
exports.mediaUrl = mediaUrl;